import { useI18N, useResponsive } from "@sundae/react-hooks";
import { Text, toolkitCx } from "@sundae/ui-toolkit";
import cx from "classnames";
import divide from "lodash/divide";
import { FC, useCallback } from "react";
import CountUp from "react-countup";
import { joyrideSelectors } from "../../../constants/joyride.constants";
import { useTasteTestContext } from "../../../pages/TasteTestDetail/context";
import { formatCurrencyToAda } from "../../../utils/number-format";
import TextLoadingPlaceholder from "../../TextLoadingPlaceholder";

const TasteTestAdaDepositedCounter: FC = () => {
  const { currentLocale, t } = useI18N("taste-test");
  const { lg } = useResponsive();
  const {
    state: { isLoading, tasteTest },
  } = useTasteTestContext();

  const handleValueFormatting = useCallback(
    (value: number /** lovelaces */) => {
      // Convert lovelaces value to ADA by dividing by 1,000,000
      return formatCurrencyToAda(divide(value, 1000000), currentLocale, {
        maximumSignificantDigits: 3,
        notation: "compact",
      });
    },
    [currentLocale]
  );

  return (
    <div
      className={cx("grid w-fit items-center", toolkitCx.layout.spacing.both.md)}
      data-guide-selector={joyrideSelectors.guides.tasteTest.interactiveGuide.totalRaised}
    >
      {isLoading ? (
        <TextLoadingPlaceholder />
      ) : (
        <CountUp
          delay={0}
          preserveValue
          formattingFn={handleValueFormatting}
          start={0}
          end={Number(tasteTest?.currentBalance?.tokenGathered?.amount)}
        >
          {({ countUpRef }) => {
            return (
              <Text
                ref={countUpRef}
                className="text-center [text-shadow:_0_1px_0_rgb(0_0_0_/_40%)]"
                tag="span"
                size={lg ? "4xl" : "2xl"}
                variant="forceLight"
              />
            );
          }}
        </CountUp>
      )}

      <Text tag="span" variant="forceLight" className="opacity-60">
        {t("detail.priceCharts.tabs.tvl")}
      </Text>
    </div>
  );
};

export default TasteTestAdaDepositedCounter;
